function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.867 25.374A6.975 6.975 0 0017.1 23.5c-3.525 0-6.419 2.61-6.906 6-4.465.327-5.108-2.003-8.294-5l-1.4 2c5.598 5.814 11.226 10.333 16.6 11 5 2 3 12.359 3 18h7s-1-7 0-9c.943-1.886 13.07-.138 14 1 2.28 2.791 1 8 1 8h7s-1.428-3.678-1-8c.428-4.322.71-9.29-2-12-2.297-2.297-9.352-1.92-14.861-2.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.6 28a.5.5 0 11-1 0 .5.5 0 111 0z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.1 29.5s5.354-11.22 9-9c5.808 3.535 2.578 18.281-4 20-2.973.777-6-7-6-7h0M47.1 36.5c2.983 2.707 5.556 3.707 7 0h0M15.1 33.5c-1 2-2.124 1.81-3.6 2",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.1 23.5c2.5-3.968 4.224-6.456 8-2"
}));

var SvgElephant = function SvgElephant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElephant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Elephant.dc79f5f5.svg";
export { ForwardRef as ReactComponent };